// The event sponsor band: the shared band arithmetic (components/Common/SponsorBand) bound to the
// event taxonomy. Three tiers, the tier stored in `category`, and every row live — an event sponsor
// has no contract that ends and no "hidden by hand"; a sponsor that should not show is removed.

import { createBandLayout } from "components/Common/SponsorBand/bandLayout"
import { EVENT_SPONSOR_TIERS } from "./sponsorPayload"

export const eventBand = createBandLayout({
  tiers: EVENT_SPONSOR_TIERS,
  tierField: "category",
})
